var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24px",
  height: "24px",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Icons/plus",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12,1 C12.5522847,1 13,1.42213152 13,1.94285714 L13,1.94285714 L13,11 L22.0571429,11 C22.5406738,11 22.9391925,11.3860402 22.9936567,11.8833789 L23,12 C23,12.5522847 22.5778685,13 22.0571429,13 L22.0571429,13 L12.999,13 L13,22.0571429 C13,22.5406738 12.6139598,22.9391925 12.1166211,22.9936567 L12,23 C11.4477153,23 11,22.5778685 11,22.0571429 L11,22.0571429 L10.999,13 L1.94285714,13 C1.45932621,13 1.06080753,12.6139598 1.00634329,12.1166211 L1,12 C1,11.4477153 1.42213152,11 1.94285714,11 L1.94285714,11 L11,11 L11,1.94285714 C11,1.45932621 11.3860402,1.06080753 11.8833789,1.00634329 Z",
  id: "\\uD83C\\uDFA8-icon-color",
  fill: "#32373C"
}))));
export { SvgPlus as ReactComponent };
export default __webpack_public_path__ + "images/plus.svg";